var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import BackgroundToggleButton from '../BackgroundToggleButton';
import Button from '../Button';
import CalendarWidget from '../CalendarWidget';
import Checkbox from '../Checkbox';
import Column from '../Column';
import ComboBox from '../ComboBox';
import ContextTable from '../ContextTableWidget';
import CountDownInput from '../CountDownInput';
import DataGrid from '../DataGrid';
import DateInput from '../DateInput';
import DynamicLabelImage from '../DynamicLabelImage';
import GridItem from '../GridItem';
import GridLayout from '../GridLayout';
import GridRow from '../GridRow';
import GroupBox from '../GroupBox';
import HBoxLayout from '../HBoxLayout';
import ImageToggleButton from '../ImageToggleButton';
import Item from '../Item';
import Label from '../Label';
import LabelImage from '../LabelImage';
import LabelWithBorders from '../LabelWithBorders';
import LatLonTextBox from '../LatLonTextBox';
import Line from '../Line';
import List from '../List';
import ListWidget from '../ListWidget';
import ListWidgetItem from '../ListWidgetItem';
import NewTreeWidget from '../NewTreeWidget';
import NumberInput from '../NumberInput';
import NumericStepper from '../NumericStepper';
import Panel from '../Panel';
import ProgressBar from '../ProgressBar';
import RadioButton from '../RadioButton';
import ReadinessSvg from '../ReadinessSvg';
import ReadOnlyDateInput from '../ReadOnlyDateInput';
import Slider from '../Slider';
import StackedWidget from '../StackedWidget';
import TabNavigator from '../TabNavigator';
import TextArea from '../TextArea';
import TextInput from '../TextInput';
import TimeInput from '../TimeInput';
import ToggleTabButton from '../ToggleTabButton';
import ToggleTextButton from '../ToggleTextButton';
import TreeWidget from '../TreeWidget';
import VBoxLayout from '../VBoxLayout';
import VideoViewer from '../VideoViewer';
import XhtmlInput from '../XhtmlInput';
var WidgetType = function (props) {
    var _a, _b;
    var type = props.type, dataItems = props.dataItems, widgetId = props.widgetId, getWidget = props.getWidget, restProps = __rest(props, ["type", "dataItems", "widgetId", "getWidget"]), propsWithTypeAttr = __assign(__assign({}, restProps), { type: type, 'data-widget-type': type, 'data-widget-id': widgetId });
    var identifier = restProps.identifier;
    switch (type.toLowerCase()) {
        case 'label':
        case 'qlabel':
        case 'customlabel':
        case 'customlabelltd':
        case 'customshapelabel':
        case 'colorcustomlabel':
        case 'colorcustomlabelltd':
            if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('img_label')) {
                return React.createElement(LabelImage, __assign({}, propsWithTypeAttr));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('dynamic_img_label')) {
                return React.createElement(DynamicLabelImage, __assign({}, propsWithTypeAttr));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('border_')) {
                return React.createElement(LabelWithBorders, __assign({}, propsWithTypeAttr));
            }
            return React.createElement(Label, __assign({}, propsWithTypeAttr));
        case 'button':
        case 'pushbutton':
        case 'pushbuttonltd':
        case 'qpushbutton':
        case 'pushbuttonimage':
        case 'sortpushbutton':
        case 'sortpushbuttonltd':
        case 'commonpushbutton':
        case 'capturebtpushbutton':
        case 'customqpushbutton':
        case 'QToolButton':
            if ((identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('img_togglebutton')) || (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('img_pushbutton'))) {
                return React.createElement(ImageToggleButton, __assign({}, propsWithTypeAttr));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('tab_pbtn')) {
                return React.createElement(ToggleTabButton, __assign({}, propsWithTypeAttr));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('text_togglebutton')) {
                return React.createElement(Button, __assign({}, propsWithTypeAttr, { isToggleButton: true }));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('toggletextbutton')) {
                return React.createElement(ToggleTextButton, __assign({}, propsWithTypeAttr));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('bg_togglebutton')) {
                return React.createElement(BackgroundToggleButton, __assign({}, propsWithTypeAttr));
            }
            else if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('content_button')) {
                return React.createElement(Button, __assign({}, propsWithTypeAttr, { contentButton: true }));
            }
            return React.createElement(Button, __assign({}, propsWithTypeAttr));
        case 'textbox':
        case 'textboxltd':
        case 'textinput':
        case 'qlineedit':
        case 'extendedtimetextbox':
        case 'colortextboxltd':
            if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('currentdate')) {
                return React.createElement(ReadOnlyDateInput, __assign({}, propsWithTypeAttr));
            }
            if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('countdown')) {
                return React.createElement(CountDownInput, __assign({}, propsWithTypeAttr));
            }
            return React.createElement(TextInput, __assign({}, propsWithTypeAttr));
        case 'qdateedit':
        case 'datetextbox':
        case 'datetextboxltd':
            return React.createElement(DateInput, __assign({}, propsWithTypeAttr));
        case 'qtimeedit':
        case 'timetextbox':
        case 'timetextboxltd':
            return React.createElement(TimeInput, __assign({}, propsWithTypeAttr));
        case 'textedit':
        case 'qtextedit':
        case 'textarea':
            return React.createElement(TextArea, __assign({}, propsWithTypeAttr));
        case 'minmaxtextbox':
        case 'minmaxtextboxltd':
        case 'integertextbox':
            return React.createElement(NumberInput, __assign({}, propsWithTypeAttr));
        case 'togglebutton':
        case 'qcheckbox':
        case 'checkbox':
            return React.createElement(Checkbox, __assign({}, propsWithTypeAttr));
        case 'qradiobutton':
        case 'radiobutton':
            return React.createElement(RadioButton, __assign({}, propsWithTypeAttr));
        case 'qcombobox':
        case 'combobox':
        case 'optionmenu':
        case 'optionmenultd':
        case 'tncombobox':
            return React.createElement(ComboBox, __assign({}, propsWithTypeAttr));
        case 'gtextedit':
            return React.createElement(XhtmlInput, __assign({}, propsWithTypeAttr));
        case 'qlistwidget':
            return React.createElement(ListWidget, __assign({}, propsWithTypeAttr));
        case 'list':
            return (React.createElement(List, __assign({}, propsWithTypeAttr, { dataItems: dataItems, getWidget: getWidget })));
        case 'item':
            return React.createElement(Item, __assign({}, propsWithTypeAttr));
        case 'qlistwidgetitem':
            return React.createElement(ListWidgetItem, __assign({}, propsWithTypeAttr));
        case 'line':
            return React.createElement(Line, __assign({}, propsWithTypeAttr));
        case 'tabletld':
        case 'datagrid':
        case 'table':
        case 'qtable':
        case 'qtablewidget':
        case 'tablewidget':
        case 'qtableview':
            if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('datalist_table')) {
                return React.createElement(ContextTable, __assign({}, propsWithTypeAttr, { dataItems: dataItems }));
            }
            return React.createElement(DataGrid, __assign({}, propsWithTypeAttr, { dataItems: dataItems }));
        case 'column':
            return React.createElement(Column, __assign({}, propsWithTypeAttr));
        case 'qhboxlayout':
        case 'hboxlayout':
        case 'qformlayout':
            return React.createElement(HBoxLayout, __assign({}, propsWithTypeAttr));
        case 'disabledlabel':
        case 'groupbox':
        case 'qgroupbox':
        case 'radiobox':
            if (type.toLowerCase() === 'disabledlabel') {
                return React.createElement(Label, __assign({}, propsWithTypeAttr, { disabled: true }));
            }
            return React.createElement(GroupBox, __assign({}, propsWithTypeAttr));
        case 'qgridlayout':
        case 'gridlayout':
            return React.createElement(GridLayout, __assign({}, propsWithTypeAttr));
        case 'gridrow':
            return React.createElement(GridRow, __assign({}, propsWithTypeAttr));
        case 'griditem':
            return React.createElement(GridItem, __assign({}, propsWithTypeAttr));
        case 'tabnavigator':
        case 'qtabwidget':
            return React.createElement(TabNavigator, __assign({}, propsWithTypeAttr));
        case 'floattextbox':
        case 'minmaxfloattextbox':
        case 'minmaxfloattextboxltd':
        case 'numericstepper':
        case 'qdoublespinbox':
        case 'qspinbox':
        case 'spinbox':
        case 'qdoublespinbox':
            return React.createElement(NumericStepper, __assign({}, propsWithTypeAttr));
        case 'customslidebar':
        case 'customslidebarltd':
        case 'qslider':
        case 'slider':
            return React.createElement(Slider, __assign({}, propsWithTypeAttr));
        case 'customprogressbar':
        case 'qprogressbar':
            return React.createElement(ProgressBar, __assign({}, propsWithTypeAttr));
        case 'qvboxlayout':
        case 'vboxlayout':
            return React.createElement(VBoxLayout, __assign({}, propsWithTypeAttr));
        case 'latlontextbox':
            return React.createElement(LatLonTextBox, __assign({}, propsWithTypeAttr));
        case 'qstackedwidget':
            return React.createElement(StackedWidget, __assign({}, propsWithTypeAttr));
        case 'qtreewidget':
            if (identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase().startsWith('newtreewidget')) {
                return React.createElement(NewTreeWidget, __assign({}, propsWithTypeAttr));
            }
            return React.createElement(TreeWidget, __assign({}, propsWithTypeAttr));
        case 'qcalendarwidget':
            return React.createElement(CalendarWidget, __assign({}, propsWithTypeAttr));
        case 'panel':
        default:
            if ((_a = restProps.identifier) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith('video')) {
                return React.createElement(VideoViewer, __assign({}, propsWithTypeAttr));
            }
            else if ((_b = restProps.identifier) === null || _b === void 0 ? void 0 : _b.toLowerCase().startsWith('svg')) {
                return React.createElement(ReadinessSvg, __assign({}, propsWithTypeAttr));
            }
            return React.createElement(Panel, __assign({}, propsWithTypeAttr));
    }
};
export default WidgetType;
//# sourceMappingURL=widgetType.js.map